import * as React from "react";
import { useTheme } from "next-themes";
import { Navbar, Footer } from "@/components/landing";
import { HowItWorksContent } from "@/components/how-it-works/HowItWorksContent";

/**
 * Public, no-login mirror of the "How it works" page at /how-it-works.
 * Wraps the shared content in the landing Navbar/Footer and renders the
 * curated static metrics snapshot (no authenticated DB query).
 */
export function PublicHowItWorksPage() {
  const { setTheme } = useTheme();

  React.useEffect(() => {
    const previous = document.title;
    document.title = "How it works — Equip Scout";
    return () => {
      document.title = previous;
    };
  }, []);

  // Force light mode on this public investor page regardless of the visitor's
  // system/stored theme. We drive next-themes itself (so it doesn't re-assert
  // the visitor's theme), then restore their prior preference on unmount.
  React.useEffect(() => {
    const previousTheme =
      typeof window !== "undefined"
        ? window.localStorage.getItem("theme")
        : null;
    setTheme("light");
    return () => {
      setTheme(previousTheme ?? "system");
    };
  }, [setTheme]);

  const year = new Date().getFullYear();

  return (
    <div className="relative min-h-screen bg-background">
      {/* Navbar is fixed; no anchor nav items on this standalone page */}
      <Navbar companyName="Equip Scout" navItems={[]} ctaText="Get Started" />

      <main className="px-4 sm:px-6 lg:px-8 pt-24 lg:pt-28 pb-20">
        <HowItWorksContent metricsMode="static" />
      </main>

      <Footer
        company={{
          name: "Equip Scout",
          description:
            "AI-powered discovery and on-site validation of sport-station locations for cities.",
          copyright: `© ${year} Equip Scout. All rights reserved.`,
        }}
        navigation={[]}
      />
    </div>
  );
}

export default PublicHowItWorksPage;
